import React, { FC } from 'react';
import { graphql } from 'gatsby';
import ImageWithFallback from '../ImageWithFallback';
import { handleRipple } from '../../helpers/ripple';
import { useMPCWidget } from '../../helpers/useMPCWidget';
import {
  StyledSection,
  StyledContentBlock,
  MainContainer,
  MainWrapperDesktop,
  FirstRowWrapperDesktop,
  BlueSection,
  ContentWrapper,
  TextWrapper,
  Title,
  Text,
  ButtonWrapper,
  SignUpButton,
  GetAppButton,
  BitcoinSection,
  BitcoinImageWrapper,
  SecondRowWrapperDesktop,
  DesktopImageSection1,
  DesktopImage1Wrapper,
  DesktopImageSection2,
  AppTitle,
  DesktopImage2Wrapper,
  MainWrapperTablet,
  FirstRowWrapperTablet,
  SecondRowWrapperTablet,
  MainWrapperMobile,
  ImageRowMobile,
} from './styled';


const ReadytoGetStarted: FC<Queries.SeoReadytoGetStartedFragment> = ({ readytogetstarted }) => {
  const { hasAccount, handleLoginClick } = useMPCWidget();

  const handleDashboardButton = async () => {
    window.open(readytogetstarted?.viewDashboardLink || undefined, '_blank');
  };

  return (
    <StyledSection>
      <StyledContentBlock>
        {readytogetstarted && (
          <MainContainer>
            <MainWrapperDesktop>
              <FirstRowWrapperDesktop>
                <BlueSection>
                  <ContentWrapper>
                    <TextWrapper>
                      <Title>{readytogetstarted?.title}</Title>
                      <Text>{readytogetstarted?.text}</Text>
                    </TextWrapper>
                    <ButtonWrapper>
                      {!hasAccount ? (
                        <SignUpButton
                          onClick={handleLoginClick}
                          onMouseEnter={handleRipple}
                        >
                          {readytogetstarted?.buttonText1}
                        </SignUpButton>
                      ) : (
                        <SignUpButton
                          onClick={() => handleDashboardButton()}
                          onMouseEnter={handleRipple}
                        >
                          {readytogetstarted?.viewDashboardButton}
                        </SignUpButton>
                      )}
                      <GetAppButton
                        href={readytogetstarted?.buttonLink2 || undefined}
                        target="_blank"
                        onMouseEnter={handleRipple}
                      >
                        {readytogetstarted?.buttonText2}
                      </GetAppButton>
                    </ButtonWrapper>
                  </ContentWrapper>
                </BlueSection>
                <BitcoinSection>
                  <BitcoinImageWrapper>
                    <ImageWithFallback
                      src={readytogetstarted?.image1?.src}
                      alt={readytogetstarted?.image1?.alt}
                    />
                  </BitcoinImageWrapper>
                </BitcoinSection>
              </FirstRowWrapperDesktop>
              <SecondRowWrapperDesktop>
                <DesktopImageSection1>
                  <DesktopImage1Wrapper>
                    <ImageWithFallback
                      src={readytogetstarted?.image2?.src}
                      alt={readytogetstarted?.image2?.alt}
                    />
                  </DesktopImage1Wrapper>
                </DesktopImageSection1>
                <DesktopImageSection2>
                  <AppTitle>{readytogetstarted?.appTitle}</AppTitle>
                  <DesktopImage2Wrapper>
                    <ImageWithFallback
                      src={readytogetstarted?.image3?.src}
                      alt={readytogetstarted?.image3?.alt}
                    />
                  </DesktopImage2Wrapper>
                </DesktopImageSection2>
              </SecondRowWrapperDesktop>
            </MainWrapperDesktop>
            <MainWrapperTablet>
              <FirstRowWrapperTablet>
                <BlueSection>
                  <ContentWrapper>
                    <TextWrapper>
                      <Title>{readytogetstarted?.title}</Title>
                      <Text>{readytogetstarted?.text}</Text>
                    </TextWrapper>
                    <ButtonWrapper>
                      {!hasAccount ? (
                        <SignUpButton
                          onClick={handleLoginClick}
                          onMouseEnter={handleRipple}
                        >
                          {readytogetstarted?.buttonText1}
                        </SignUpButton>
                      ) : (
                        <SignUpButton
                          onClick={() => handleDashboardButton()}
                          onMouseEnter={handleRipple}
                        >
                          {readytogetstarted?.viewDashboardButton}
                        </SignUpButton>
                      )}
                      <GetAppButton
                        href={readytogetstarted?.buttonLink2 || undefined}
                        target="_blank"
                        onMouseEnter={handleRipple}
                      >
                        {readytogetstarted?.buttonText2}
                      </GetAppButton>
                    </ButtonWrapper>
                  </ContentWrapper>
                </BlueSection>
              </FirstRowWrapperTablet>
              <SecondRowWrapperTablet>
                <BitcoinSection>
                  <BitcoinImageWrapper>
                    <ImageWithFallback
                      src={readytogetstarted?.image1?.src}
                      alt={readytogetstarted?.image1?.alt}
                    />
                  </BitcoinImageWrapper>
                </BitcoinSection>
                <DesktopImageSection1>
                  <DesktopImage1Wrapper>
                    <ImageWithFallback
                      src={readytogetstarted?.image2?.src}
                      alt={readytogetstarted?.image2?.alt}
                    />
                  </DesktopImage1Wrapper>
                </DesktopImageSection1>
                <DesktopImageSection2>
                  <AppTitle>{readytogetstarted?.appTitle}</AppTitle>
                  <DesktopImage2Wrapper>
                    <ImageWithFallback
                      src={readytogetstarted?.image3?.src}
                      alt={readytogetstarted?.image3?.alt}
                    />
                  </DesktopImage2Wrapper>
                </DesktopImageSection2>
              </SecondRowWrapperTablet>
            </MainWrapperTablet>
            <MainWrapperMobile>
              <BlueSection>
                <ContentWrapper>
                  <TextWrapper>
                    <Title>{readytogetstarted?.title}</Title>
                    <Text>{readytogetstarted?.text}</Text>
                  </TextWrapper>
                  <ButtonWrapper>
                    {!hasAccount ? (
                      <SignUpButton
                        onClick={handleLoginClick}
                        onMouseEnter={handleRipple}
                      >
                        {readytogetstarted?.buttonText1}
                      </SignUpButton>
                    ) : (
                      <SignUpButton
                        onClick={() => handleDashboardButton()}
                        onMouseEnter={handleRipple}
                      >
                        {readytogetstarted?.viewDashboardButton}
                      </SignUpButton>
                    )}
                    <GetAppButton
                      href={readytogetstarted?.buttonLink2 || undefined}
                      target="_blank"
                      onMouseEnter={handleRipple}
                    >
                      {readytogetstarted?.buttonText2}
                    </GetAppButton>
                  </ButtonWrapper>
                </ContentWrapper>
              </BlueSection>
              <ImageRowMobile>
                <BitcoinSection>
                  <BitcoinImageWrapper>
                    <ImageWithFallback
                      src={readytogetstarted?.image1?.src}
                      alt={readytogetstarted?.image1?.alt}
                    />
                  </BitcoinImageWrapper>
                </BitcoinSection>
                <DesktopImageSection1>
                  <DesktopImage1Wrapper>
                    <ImageWithFallback
                      src={readytogetstarted?.image2?.src}
                      alt={readytogetstarted?.image2?.alt}
                    />
                  </DesktopImage1Wrapper>
                </DesktopImageSection1>
              </ImageRowMobile>
              <DesktopImageSection2>
                <AppTitle>{readytogetstarted?.appTitle}</AppTitle>
                <DesktopImage2Wrapper>
                  <ImageWithFallback
                    src={readytogetstarted?.image3?.src}
                    alt={readytogetstarted?.image3?.alt}
                  />
                </DesktopImage2Wrapper>
              </DesktopImageSection2>
            </MainWrapperMobile>
          </MainContainer>
        )}
      </StyledContentBlock>
    </StyledSection>
  );
};

export const query = graphql`
  fragment SeoReadytoGetStarted on Json {
    readytogetstarted {
      title
      text
      buttonText1
      viewDashboardButton
      viewDashboardLink
      buttonText2
      buttonLink2
      appTitle
      image1 {
        src
        alt
      }
      image2 {
        src
        alt
      }
      image3 {
        src
        alt
      }
    }
  }
`;

export default ReadytoGetStarted;
